import {createReducer} from '@reduxjs/toolkit'
import {showDemoEvents, showNoEvents} from '../actions/view'
import {View} from '../types/state'

const defaultState: View = {
  demo: false,
  noEvents: false,
}

export const viewReducer = createReducer(defaultState, builder => {
  builder
    .addCase(showDemoEvents, state => {
      state.demo = true
    })
    .addCase(showNoEvents, (state, action) => {
      state.noEvents = action.payload
    })
})
